export default __webpack_public_path__ + "static/media/logonorris.a984d008.png";